export const CoreConstantsEn = {
  lang: 'en',
  data: {
    CONSTANTS: {
      DELETE: {
        TITLE: 'Delete',
        MESSAGE: 'Do you want to delete this?',
      },
      CONFIRMATION: {
        TITLE: 'Confirmation',
        MESSAGE: 'Do you want to continue?',
      },
      GRID_MESSAGE: {
        LOADING: 'Loading...',
        NO_RECORD: 'No records available.',
      },
      BUTTONS: {
        SAVE: 'Save',
        UPDATE: 'Update',
        BACK: 'Back',
        DELETE: 'Delete',
        DELETE_INVITE: 'Delete Invite',
        SUBMIT: 'Submit',
        CANCEL: 'Cancel',
        ADD: 'Add',
        BLOCK: 'Block',
        REVOKE: 'Revoke',
        EDIT: 'Edit',
        MORE: 'More vert',
        YES: 'Yes',
        NO: 'No',
        CLOSE: 'Close',
        VIEW: 'View',
        SEND: 'Send',
        APPROVE: 'Approve',
        REJECT: 'Reject',
        VERIFY: 'Verify',
        SEARCH: 'Search',
        OK: 'OK',
        CLEAR: 'Clear',
        CREATE: 'Create',
        RESET: 'Reset',
        GENERATE: 'Generate',
        REFRESH: 'Refresh',
        NEXT: 'Next',
        PREVIEW: 'Preview',
        REMOVE: 'Remove',
        APPLY: 'Apply',
        GO_BACK: 'Go Back',
        DOWNLOAD: 'Download',
        CONTINUE: 'Continue',
        COPY: 'Copy',
        EXPORT_TO_EXCEL: 'Export to Excel',
        VIEW_FULL: 'View Full Page',
        INVITE: 'Invite',
      },
      VALIDATION: {
        REQUIRED: 'This field is required',
        EDIT: 'Edit',
        EMAIL: 'Please enter a valid email.',
        NUMBER: 'Please enter valid number.',
        REQUIRED_FIELDS: ' * Field is Required.',
        MAXIMUM_NUMBER_DOCUMENTS_ERROR: 'Maximum number of Documents exceeded. Maximum upload Number: 5',
        INVALID_FILE_TYPE: 'Unsupported file format.',
        MAX_SIZE: 'Max file size limit is 50mb',
      },
      ACTION: 'Action',
      ACTIONS: 'Action(s)',
      PROMPT_DIALOG: {
        ENTER_VALUE: 'Enter value',
      },
      ORGANIZATION_BLOCKED_TOASTER: 'Your organization has been deactivated, please contact system administrator',
    },
  },
};
